import { useEffect, useRef, useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import './TileLayerControl.css';

const TILE_LAYERS = [
  {
    name: "Par défaut",
    url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
  },
  {
    name: "Gris clair",
    url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
  },
  {
    name: "Satellite",
    url: "https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  }
];

const LayersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
  </svg>
);

const TileLayerControl = () => {
  const map = useMap();
  const tileLayersRef = useRef({});
  const activeLayerRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Créer les couches de tuiles
    const layers = {};
    TILE_LAYERS.forEach(layer => {
      const tileLayer = L.tileLayer(layer.url);
      layers[layer.name] = tileLayer;
    });
    tileLayersRef.current = layers;

    // Activer la première couche par défaut
    const defaultLayer = TILE_LAYERS[0].name;
    layers[defaultLayer].addTo(map);
    activeLayerRef.current = defaultLayer;

    return () => {
      // Nettoyer les couches lors du démontage
      Object.values(layers).forEach(layer => {
        map.removeLayer(layer);
      });
    };
  }, [map]);

  const handleLayerChange = (layerName) => {
    if (activeLayerRef.current) {
      map.removeLayer(tileLayersRef.current[activeLayerRef.current]);
    }
    map.addLayer(tileLayersRef.current[layerName]);
    activeLayerRef.current = layerName;
  };

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsExpanded(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsExpanded(false);
    }, 300);
  };

  return (
    <div 
      className={`tile-layer-control ${isExpanded ? 'expanded' : ''}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="control-icon">
        <LayersIcon />
      </div>
      <div className="layers-list">
        {TILE_LAYERS.map((layer, index) => (
          <div 
            key={layer.name}
            className={`layer-option ${activeLayerRef.current === layer.name ? 'active' : ''}`}
            onClick={() => handleLayerChange(layer.name)}
          >
            <div className="layer-preview">
              <img 
                src={`${layer.url.replace('{s}', 'a').replace('{z}', '5').replace('{x}', '16').replace('{y}', '11')}`}
                alt={layer.name}
                width="40"
                height="40"
              />
            </div>
            <span className="layer-name">{layer.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TileLayerControl;